// RC8 — Padrão único de timezone: America/Sao_Paulo (UTC-3, sem DST desde 2019).
// O horário digitado/exibido é SEMPRE hora de São Paulo, independente do fuso do navegador.
export const SP_TZ = "America/Sao_Paulo";
export const SP_OFFSET = "-03:00";

// "2026-07-13T14:00" (datetime-local) → ISO com offset SP: "2026-07-13T14:00:00-03:00"
export function spLocalToIso(local) {
  if (!local) return local;
  const base = local.length === 16 ? `${local}:00` : local;
  return `${base}${SP_OFFSET}`;
}

// ISO (qualquer offset) → chave de dia em SP: "2026-07-13"
export function spDateKey(iso) {
  try {
    return new Date(iso).toLocaleDateString("en-CA", { timeZone: SP_TZ });
  } catch { return ""; }
}
